import React, { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import './App.css';
import RoutesPath from './routes';
import { CssBaseline } from '@mui/material';
import { Toaster } from 'react-hot-toast';
import { enqueueSnackbar } from 'notistack';
import { onMessageListener } from './firebase';
import { ThemeProvider } from './utils/ThemeContext';

function App() {
  useEffect(() => {
    onMessageListener().then(payload => {
      console.log('Foreground notification:', payload);
      enqueueSnackbar(payload.data.title_ar + ': ' + payload.data.body_ar);
    });
  }, []);

  return (
    <ThemeProvider>
      <CssBaseline />
      <BrowserRouter>
        <RoutesPath />
      </BrowserRouter>
      <Toaster
        position="top-center"
        gutter={12}
        containerStyle={{ margin: "8px" }}
        toastOptions={{
          success: {
            duration: 3000,
          },
          error: {
            duration: 5000,
          },
          style: {
            fontSize: "16px",
            maxWidth: "500px",
            padding: "16px 24px",
            backgroundColor: theme => theme.palette.primary.main,
            color: theme => theme.palette.primary.contrastText,
          },
        }}
      />
    </ThemeProvider>
  );
}

export default App;
